export const WEDDING = {
  bride: "Yoshita",
  groom: "Jinkle",
  date: "2026-11-26T18:00:00+05:30",
  dateLabel: "26 · November · 2026",
  dateLong: "Thursday, 26 November 2026",
  venue: "Aashish Vatika",
  city: "Udaipur, Rajasthan",
  tagline: "Two souls. One monsoon. A forever begins by the lakes of Mewar.",
  mapsQuery: "Aashish+Vatika+Udaipur+Rajasthan",
};

export const MEDIA = {
  ourStoryImg:"https://res.cloudinary.com/df7dpbwpq/image/upload/v1777640681/IMG_0643.JPG_pzvtax.jpg",
  hero_palace:"https://images.unsplash.com/photo-1702928124104-0189b120b210?q=80&w=1035&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    // "https://static.prod-images.emergentagent.com/jobs/449e4772-92ce-4db1-a14b-7822007acf92/images/8b5a6ddb138a480a133be0d7a19d3c149fe72f1706cc4711b45bf1f6b6ebd3b5.png",
  aprilImg:
    "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782537396/IMG_0274_yagmpk.jpg",
  cinematic_texture:
    "https://static.prod-images.emergentagent.com/jobs/449e4772-92ce-4db1-a14b-7822007acf92/images/25b6b05db2f8236a83f09892c0b5a40c9baa09f46bfa927cd2b720a4427b9034.png",
  details_curated:
    "https://res.cloudinary.com/df7dpbwpq/image/upload/v1777647238/IMG_0854_eti6xm.jpg",
  // details_curated: "https://static.prod-images.emergentagent.com/jobs/449e4772-92ce-4db1-a14b-7822007acf92/images/246784e0822bcc7f0d409ae606824423f79960298b2eefbd6d590e21d5602f61.png",
  // story_floral:"https://res.cloudinary.com/df7dpbwpq/image/upload/v1777640682/IMG_0648.JPG_meeaox.jpg",
  raw1: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558680/IMG_8914_wmon4t.jpg",
  story_floral:
    "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558676/IMG_6649_prhrxo.jpg",
  raw2: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782559047/IMG_4749_ryxwzk.jpg",
  // raw2: "https://images.unsplash.com/photo-1649565080348-56864660b36e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjB3ZWRkaW5nJTIwY291cGxlJTIwc3Vuc2V0fGVufDB8fHx8MTc3NzYyMDE0MXww&ixlib=rb-4.1.0&q=85",
  raw3: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558677/IMG_7136_ymeh2l.jpg",
  palace_arch:
    "https://images.unsplash.com/photo-1721572322100-014f13725864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxVZGFpcHVyJTIwcGFsYWNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3NzYyMDE0MXww&ixlib=rb-4.1.0&q=85",
  palace_door:
    "https://images.unsplash.com/photo-1721572321878-46fbef2e4bbd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxVZGFpcHVyJTIwcGFsYWNlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc3NzYyMDE0MXww&ixlib=rb-4.1.0&q=85",
};

export const RAW_IMAGES = {
  raw1: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558680/IMG_9238_c5nukh.jpg",
  raw2: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558677/IMG_7135_jgu4z9.jpg",
  raw3: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558674/IMG_6174_zpy0bs.jpg",
  raw4: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782537399/IMG_0415_sepkyj_iswsld.jpg",
  raw5: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782558669/IMG_6293_y1lkbu.jpg",
  raw6: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782559218/IMG_8479_invyph.jpg",
};

export const JOURNEY = [
  {
    month: "November 2025",
    title: "Where It Began",
    note: "Two families, one quiet hope, and a roka in Kherwara on the 23rd that turned two strangers into something neither of us had a word for yet. Our first date — equal parts nervous and certain.",
    image: MEDIA.raw2,
  },
  {
    month: "January 2026",
    title: "A Rooftop, A Surprise",
    note: "December had pulled me back to Bangalore, the distance doing most of the talking again. I returned home in mid-January — and on the 28th, she'd quietly planned a private rooftop evening just for my birthday. That was the night I felt chosen, not just matched.",
    image: MEDIA.story_floral,
  },
  {
    month: "February 2026",
    title: "Learning Each Other",
    note: "Another visit, another set of ordinary hours that didn't feel ordinary at all. The calls had taught us facts about each other; this taught us each other.",
    image: MEDIA.raw3,
  },
  {
    month: "March 2026",
    title: "She Came to Bangalore",
    note: "My city, through her eyes, for the first time. Watching her take it in — and realizing I wanted to be the one showing her everything, always.",
    image: MEDIA.raw1,
  },
  {
    month: "April 2026",
    title: "Rishikesh, Among Friends",
    note: "A friend's wedding, the Ganga close by, and us — no longer the new couple everyone was curious about, just two people who already felt like home to each other.",
    image: MEDIA.aprilImg,
  },
  {
    month: "November 2026",
    title: "The Forever",
    note: "26th November, Udaipur. Where the lakes hold a thousand stories, we begin to write ours.",
    image: MEDIA.hero_palace,
  },
];

export const EVENTS = [
  {
    key: "ring",
    name: "Ring Ceremony",
    date: "15 November 2026",
    time: "Evening",
    city: "Kherwara",
    venue: "Kherwara, Rajasthan",
    note: "Where it was made official — two families, one quiet promise, rings exchanged among the people who've known us longest.",
  },
  {
    key: "mehendi",
    name: "Mehendi",
    date: "23 November 2026",
    time: "Evening",
    city: "Kherwara",
    venue: "Kherwara (Hometown)",
    note: "A small, intimate function at home — henna, music, and the first real stirrings of wedding season.",
  },
  {
    key: "haldi",
    name: "Haldi",
    date: "25 November 2026",
    time: "Morning",
    city: "Udaipur",
    venue: "Aashish Vatika, Udaipur",
    note: "A golden, glowing morning — turmeric, laughter, and blessings from everyone who's watched us get here.",
  },
  {
    key: "dev-darshan",
    name: "Dev Darshan",
    date: "25 November 2026",
    time: "Afternoon",
    city: "Udaipur",
    venue: "Aashish Vatika, Udaipur",
    note: "A quiet pause in the middle of the celebrations — seeking blessings before the festivities rise again by nightfall.",
  },
  {
    key: "sangeet",
    name: "Sangeet",
    date: "25 November 2026",
    time: "Night",
    city: "Udaipur",
    venue: "Aashish Vatika, Udaipur",
    note: "Music, dance, and a few stories that really shouldn't be told in front of the elders — but will be anyway.",
  },
  {
    key: "wedding",
    name: "Shadi & Baraat",
    date: "26 November 2026",
    time: "Morning",
    city: "Udaipur",
    venue: "Aashish Vatika, Udaipur",
    note: "The Baraat arrives, the rituals begin, and somewhere in the middle of it all, two become one.",
  },
  {
    key: "reception",
    name: "Reception",
    date: "26 November 2026",
    time: "Evening",
    city: "Udaipur",
    venue: "Aashish Vatika, Udaipur",
    note: "The day's final toast — lake breeze, soft lights, and a celebration with everyone who made the journey.",
  },
];

export const HER_PHOTOS = [
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782569312/IMG_8402_ylbjuh.jpg", caption: "cute" },
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782569347/IMG_9710_yzbfab.jpg", caption: "pout" },
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782569312/IMG_8943_r5ndbh.jpg", caption: "attitude" },
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782569311/IMG_8161_b04vqc.jpg", caption: "childish" },
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782569311/IMG_7124_eluwlb.jpg", caption: "wavy" },
  { src: "https://res.cloudinary.com/df7dpbwpq/image/upload/v1782559219/IMG_7607_hyvd6s.jpg", caption: "snap filter" },
];